import React from "react";
import MainLoader from "../MainLoader";
const ProductDetailsLoader = () => {
    return (
        <MainLoader />
    )
}

export default ProductDetailsLoader;